import { Admin, CustomRoutes } from "react-admin";
import jsonServerProvider from "ra-data-json-server";
import { BrowserRouter, Route, Routes } from "react-router";
import AuthLogin from "./screens/authLogin";
import AuthRegister from "./screens/authRegister";
import AuthPasswordReset from "./screens/authPasswordReset";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MainLogin from "./screens/mainLoign";
import { createStore } from "little-state-machine";
import * as Sentry from "@sentry/react";
import AuthConfirmation from "./screens/authConfirmation";
import BrushingReportFeedback from "./screens/brushingReportFeedback";
import AuthPasswordResetConfirm from "./screens/authPasswordResetConfirm";
import NotFound404 from "./screens/notFound404";

const dataProvider = jsonServerProvider("https://jsonplaceholder.typicode.com");

const queryClient = new QueryClient();

createStore(
  {
    loginPageData: {
      redirectUrl: import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_URL,
      cookieDomain: import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_COOKIE_DOMAIN || ".sunstargum.com",
    },
    developerSettings: {
      socialLoginEnabled: false,
    },
  },
  { name: "GUM_SSO" },
);

if (import.meta.env.VITE_PUBLIC_DEV === "false") {
  Sentry.init({
    dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

const App = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/" element={<MainLogin />} />
        <Route path="/auth/login" element={<AuthLogin />} />
        <Route path="/auth/register" element={<AuthRegister />} />
        <Route path="/auth/forgot-password" element={<AuthPasswordReset />} />
        <Route path="/auth/verify-email/:token" element={<AuthConfirmation />} />
        <Route path="/api/v2/auth/verify-email/:token" element={<AuthConfirmation />} />
        <Route path="/api/v2/yotdfeedback/:feedback_code/:feedback_value" element={<BrushingReportFeedback />} />
        <Route path="/auth/reset-password/confirm/:token" element={<AuthPasswordResetConfirm />} />
        <Route
          path="/admin/*"
          element={
            <Admin disableTelemetry catchAll={NotFound404} dataProvider={dataProvider}>
              <CustomRoutes noLayout>
                <Route path="/" element={<MainLogin />} />
                {/* <Route path="/checkout" element={<Checkout />} />            
                    <Route path="/checkout/:checkoutId/processing" element={<Checkout processing={true} />} />
                    <Route path="/checkout/:cartId" element={<Checkout />} />
                    <Route path="/checkout/:checkoutId/customer" element={<Checkout />} />
                    <Route path="/checkout/:checkoutId/payment" element={<Checkout />} />
                    <Route path="/thank_you/:checkoutId" element={<ThankYou />} />
                    <Route path="/thank_you/" element={<ThankYou />} /> */}
              </CustomRoutes>
            </Admin>
          }
        />
        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </QueryClientProvider>
  </BrowserRouter>
);

export default App;
